import React from "react";
import classNames from "classnames";
import { ProgressIndicator } from "@toddle-edu/ds-web";

import classes from "./ProgressBar.scss";

const ProgressBar = props => {
  const { t, questionCount, attemptedCount } = props;

  const progressValue = attemptedCount / questionCount;

  const progressBarText = t("common:lowercase", {
    text: t("worksheet:attempted"),
  });
  const headerRightTextContent = `${attemptedCount}/${questionCount} ${progressBarText}`;

  const outlineProgressBarTextClass = classNames({
    ["text-body-3"]: true,
    [classes.outlineProgressBarText]: true,
  });

  return (
    <div className={classes.outline}>
      <div className={classes.outLineHeader}>
        <div className={classes.outLineLeftContainer}>
          <div className="text-label-2">{t("worksheet:questions")}</div>
        </div>
        <div className={outlineProgressBarTextClass}>
          {headerRightTextContent}
        </div>
      </div>
      {questionCount > 0 ? (
        <div className={classes.progressBar}>
          <ProgressIndicator
            variant="progress-bar"
            progress={progressValue * 100}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ProgressBar;
